export enum ProjectType {
  standard = 'standard',
  experimental = 'experimental',
}
